import React from "react";
import {ControlLabel, FormControl, Radio, Button} from "react-bootstrap";
import DatePicker from "react-bootstrap-date-picker";
import {browserHistory} from "react-router";
import context from "./../../lib/context.js";
import TimecardList from "./../shared/timecard-list.jsx";

export default class SearchForm extends React.Component {
    constructor(props) {
        super(props);       
        this.onFieldChange = this.onFieldChange.bind(this);      
        this.countSelectedItem = this.countSelectedItem.bind(this);
        this.updateTextFields = this.updateTextFields.bind(this);
        this.inputs = {};
    }

    onFieldChange(fieldName, value, callback) {       
        var patch = {
            [fieldName] : value
        };        
        this.props.onFieldChange({search: patch}, callback);
    }
        
    updateTextFields(callback) {
        var patch = {
            associateName : this.inputs.associateName.value,
            office: this.inputs.office.value
        };        
        this.props.onFieldChange({search: patch}, callback);
    }

    countSelectedItem() {
        try {
            let count = 0;
            let vm = this.props.vm;
            for(let i = 0; i < vm.timecardList.timecards.length; i++) {
                let tc = vm.timecardList.timecards[i].timecardSummary;                
                if (tc.isChecked && !(tc.isEdited || tc.isIncomplete)) count ++;
            }

            return count;
        } catch(e) {
            console.log(e);
            return 0;
        }
    }

    render() {  
        const self = this;
        let vm = this.props.vm;        
        let companies = [];        
        if (vm != null) {          
            companies.push(
                <option key="all" value="">All</option>
            );

            if (vm.companies != null) {
                for(var i = 0; i< vm.companies.length; i++) {
                    if (vm.companies[i] !== "") {
                        companies.push(
                                <option key={vm.companies[i]} value={vm.companies[i]}>{vm.companies[i]}</option>
                            );
                    }
                }
            }
            
            let totalPage = vm.timecardList.total / vm.pageSize + 
            (vm.timecardList.total % vm.pageSize > 0 ? 1 : 0);        
            let verifyTcButtonClass = "ap-fullsize ";
            let verifyTcButtonDisabled = false;
            if (this.countSelectedItem() > 0) verifyTcButtonClass += "btn-info";
            else verifyTcButtonDisabled = true;

            return(            
                <div className="container">                
                    <div className="row">
                        <div className="col-md-8">
                            <ControlLabel>Associate Name</ControlLabel>
                            <FormControl type="text" placeholder="Last name, First name" list="peopleName" 
                            defaultValue={vm.associateName}
                            ref="associateName" inputRef={node => self.inputs.associateName = node}/>                             
                        </div>                
                        <div className="col-md-4">
                            <ControlLabel>WeekEnding Date</ControlLabel>
                            <DatePicker placeholder="MM/DD/YYYY"
                            value={vm.weekEndingDate} 
                            onChange={(val, formattedVal) => this.onFieldChange("weekEndingDate", val)}
                            onInput={(val, formattedVal) => this.onFieldChange("weekEndingDate", val)}/>
                        </div>                
                    </div>
                    <div className="row">
                        <div className="col-md-4">                            
                            <Radio name="radioTCStatus" value="submitted" 
                            checked={vm.status === "submitted"} 
                            onChange={(evt) => this.onFieldChange("status", evt.target.value)}>Submitted Timecards</Radio>
                            <Radio name="radioTCStatus" value="saved" 
                            checked={vm.status === "saved"} 
                            onChange={(evt) => this.onFieldChange("status", evt.target.value)}>Unsubmitted Timecards</Radio>                            
                        </div>
                        <div className="col-md-4">
                            <ControlLabel>Office</ControlLabel>
                            <FormControl type="text" placeholder="Office ID" list="officeList"                            
                            defaultValue={vm.office}
                            ref="office" inputRef={node => self.inputs.office = node}/>
                        </div>

                        <div className="col-md-4">
                            <ControlLabel>Company</ControlLabel>
                            <FormControl componentClass="select" 
                            value={vm.company} onChange={(evt) => this.onFieldChange("company", evt.target.value)}>
                                {companies}
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Button className="ap-fullsize btn-info" onClick={() => {
                                self.updateTextFields(() => self.props.onSearch());
                            }}>Search</Button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">                            
                            <TimecardList vm={vm.timecardList} totalPage={totalPage} page={vm.page} onNavigate={this.props.onNavigate}                            
                            onTcItemChecked={this.props.onTcItemChecked} role={this.props.role}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Button className={verifyTcButtonClass} onClick={() => {
                                    self.updateTextFields(() => self.props.onVerify());
                                }}
                                disabled={verifyTcButtonDisabled}>Verify Selected Timecards</Button>
                        </div>
                    </div>                    
                </div>
                );            
        } else {
            return(
                <div className="container">
                    <div className="row">
                        
                    </div>
                </div>
                );
        }
    }
}